/**
 * Merges all component category overrides into a single components object for createTheme().
 * @see https://mui.com/material-ui/customization/theme-components/
 */
import type { Components, Theme } from '@mui/material';

import { buttonComponents } from './buttons';
import { dataDisplayComponents } from './data-display';
import { feedbackComponents } from './feedback';
import { inputComponents } from './inputs';
import { navigationComponents } from './navigation';
import { surfaceComponents } from './surfaces';

export const components: Components<Omit<Theme, 'components'>> = {
    ...inputComponents,
    ...buttonComponents,
    ...navigationComponents,
    ...feedbackComponents,
    ...dataDisplayComponents,
    ...surfaceComponents,
};
